var ACTDIG = ACTDIG || (ACTDIG = {});

ACTDIG.ExtendOwl = (function ($, window, document) {
    return {
        init: function () {
            var $container = $('.owl-container');
            $container.on('click', '.owl-next', function (e) {
                $(this).closest('.owl-container').find('.owl-carousel').trigger('next.owl.carousel');
            });

            $container.on('click', '.owl-prev', function (e) {
                $(this).closest('.owl-container').find('.owl-carousel').trigger('prev.owl.carousel');
            });
        }
    };
})(window.jQuery, window, document);

ACTDIG.owlTrusted = (function ($, window, document) {

    return {
        init: function () {
            $("#brands-carousel").owlCarousel($.extend({}, ACTDIG.Config.owlDefaults, {
                loop: true,
                dots: false,
                slideSpeed: 800,
                autoplay: 3000,
                paginationSpeed: 1000,
                rewindSpeed: 1000,
                responsiveClass: true,
                items: 6,
                margin: 22,
                responsive: {
                    0: {
                        dots: true,
                        items: 4,
                        margin: 22,
                    },
                    992: {
                        dots: false,
                        items: 5,
                        margin: 22,
                    },
                    1200: {
                        items: 6,
                        margin: 30,
                    },
                }
            }));
        }
    };
})(window.jQuery, window, document);

var ACTDIG = ACTDIG || (ACTDIG = {});

ACTDIG.Testimonials = (function ($, window, document) {

    return {
        init: function () {
            $("#testimonials-carousel").owlCarousel($.extend({}, ACTDIG.Config.owlDefaults, {
                dots: true,
                responsiveClass: true,
                items: 3,
                margin: 22,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 2,
                    },
                    1200: {
                        items: 3,
                    },
                }
            }));
        }
    };
})(window.jQuery, window, document);

ACTDIG.CaseStudyFlipsterGallery = (function ($, window, document) {

    function initFlipster() {
        var flipContainer = $('.flipster'),
            flipItemContainer = flipContainer.find('.flip-items'),
            flipItem = flipContainer.find('li');

        flipContainer.flipster({
            itemContainer: flipItemContainer,
            itemSelector: flipItem,

            loop: true,
            // autoplay: 4000,
            buttons: 'custom',
            nav: 'after',

            start: 'center',
            style: 'infinite-carousel',
            spacing: 0,
            scrollwheel: false,

            buttonPrev: '<span class="icon icon-arrow left"></span> Back',
            buttonNext: 'Next <span class="icon icon-arrow right"></span>',
        });

        // Nav
        setTimeout(function () {
            if (flipContainer.find('.flipster__nav-2').length == 0) {
                flipContainer.find('.flipster__nav')
                    .wrap('<div class="flipster__nav-2"></div>');

                flipContainer.find('.flipster__button--prev')
                    .prependTo(flipContainer.find('.flipster__nav-2'));

                flipContainer.find('.flipster__button--next')
                    .appendTo(flipContainer.find('.flipster__nav-2'));
            }

            setTimeout(function () {
                $('.flipster').addClass('show');

                $('.image-gallery').addClass('active');
            }, 450);

        }, 250);

        // AOS.refresh();
    }

    return {
        init: function () {
            initFlipster();
        }
    };
})(window.jQuery, window, document);

ACTDIG.Datepicker = (function ($, window, document) {

    return {
        init: function () {
            $(".datepicker").datepicker({
                minDate: -20,
                maxDate: "+1M +10D",
                altField: "#inputDate",
                altFormat: "DD d MM yy"
            });
        }
    };
})(window.jQuery, window, document);

ACTDIG.FancyBox = (function ($, window, document) {

    return {
        init: function () {
            if (typeof $.fancybox !== 'undefined') {
                $('[data-fancybox]').fancybox({
                    // Options will go here
                    smallBtn: true,
                    toolbar: true,
                    buttons: [
                        "zoom",
                        //"share",
                        "slideShow",
                        //"fullScreen",
                        //"download",
                        "thumbs",
                        "close"
                    ]
                });
            }
        }
    };
})(window.jQuery, window, document);